const LEADS_ENDPOINT =
  import.meta.env.VITE_LEADS_ENDPOINT ?? 'https://rbllc.vercel.app/api/leads';

export interface LeadPayload {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  location?: string;
  projectSize?: string;
  description?: string;
  /** Honeypot — must stay empty. */
  website?: string;
}

/** Submit a bid request to the Revive Builders platform. */
export async function submitLead(payload: LeadPayload): Promise<boolean> {
  try {
    const res = await fetch(LEADS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) return false;
    const data = (await res.json()) as { ok?: boolean };
    return data.ok === true;
  } catch {
    return false;
  }
}
